import { DeliveryStatus } from 'api/models/Deliveries';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import routes from 'routes';

const STATUSES_FOR_CHECK_OUT: DeliveryStatus[] = [
  'CHECKED_IN',
  'PARTIALLY_CHECKED_OUT',
  'OVERDUE_FOR_CHECK_OUT',
  'CHECKED_OUT',
  'DELETED',
  'CANCELED',
];

const useNavigateToDeliveryDetailPage = () => {
  const navigate = useNavigate();

  const navigateToDeliveryDetailPage = useCallback(
    (deliveryId: number, deliveryStatus: DeliveryStatus) => {
      // dispatched deliveries go to the view-dispatch page
      const isDispatchedStatus = deliveryStatus == 'OUTBOUND';
      if (isDispatchedStatus) {
        navigate(routes.ViewDispatch.makePath(deliveryId));
        return;
      }

      const isStatusForCheckOut = STATUSES_FOR_CHECK_OUT.includes(deliveryStatus);
      if (isStatusForCheckOut) {
        navigate(routes.CheckOut.makePath(deliveryId));
        return;
      }

      // active/current deliveries go to the check-in page
      navigate(routes.CheckIn.makePath(deliveryId));
    },
    [navigate],
  );

  return navigateToDeliveryDetailPage;
};

export default useNavigateToDeliveryDetailPage;
